import React from 'react';
import { Button, Card, Select, Tag } from 'antd';

const { Option } = Select;

export default function OrderShipmentSummaryCard(props) {
    const {
        shipmentSummary = {},
        shipmentActions = {},
        shipmentLockState = {},
        onOpenCreateDrawer,
        onPrintLabel,
        printFormat,
        onPrintFormatChange,
        onViettelUpdate,
        onViettelCancel
    } = props;

    return (
        <Card title="Shipment">
            {shipmentSummary.has_shipment ? (
                <div>
                    <div><strong>Provider:</strong> {shipmentSummary.provider || ''}</div>
                    <div><strong>Mã vận đơn:</strong> {shipmentSummary.provider_order_code || ''}</div>
                    <div><strong>Trạng thái:</strong> <Tag>{shipmentSummary.shipment_status || ''}</Tag></div>
                </div>
            ) : (
                <div>
                    <div>Chưa có shipment</div>
                    {shipmentActions.create_block_reason ? <div style={{ color: '#999', marginTop: 8 }}>{shipmentActions.create_block_reason}</div> : null}
                </div>
            )}
            {shipmentLockState.locked_after_shipment ? <div style={{ color: '#999', marginTop: 12 }}>{shipmentLockState.lock_reason}</div> : null}
            <div className="d-flex" style={{ gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
                {shipmentActions.can_create_shipment ? (
                    <Button type="primary" onClick={onOpenCreateDrawer}>Tạo shipment</Button>
                ) : null}
                {shipmentSummary.has_shipment && shipmentSummary.provider === 'viettel_post' ? (
                    <>
                        <Select value={printFormat} style={{ width: 90 }} onChange={onPrintFormatChange}>
                            <Option value="a5">A5</Option>
                            <Option value="a6">A6</Option>
                            <Option value="a7">A7</Option>
                        </Select>
                        <Button onClick={onPrintLabel}>In vận đơn</Button>
                        <Button onClick={onViettelUpdate}>Cập nhật Viettel</Button>
                        <Button danger onClick={onViettelCancel}>Hủy Viettel</Button>
                    </>
                ) : null}
            </div>
        </Card>
    );
}
